module.exports = __webpack_public_path__ + "static/media/documents-blank.53b2c208.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/documents-blank.svg
// module id = 1361
// module chunks = 0